module.exports = __webpack_public_path__ + "img/festival_chinesenewyear2.7fc6d608.png";